module.exports = __webpack_public_path__ + "fonts/TheBoldFont.0727d9be.eot";